import { DrillingMultiAnalysisWidgetEntity } from 'src/pages/dashboard/features/drilling-multi-analysis-widget/DrillingMultiAnalysisWidget.entity';
import { parseDrillingMultiAnalysisWidgetInternalState } from 'src/pages/dashboard/features/drilling-multi-analysis-widget/parseDrillingMultiAnalysisWidget';
import type { TSerializedWidgetTemplate } from 'src/pages/dashboard/features/workspace/Workspace.store';

export function mapDrillingMultiAnalysisTemplate(
  template: TSerializedWidgetTemplate,
  index: number,
  options?: { wellId: number | null },
): DrillingMultiAnalysisWidgetEntity {
  const { size, position } = template;
  const internalState = parseDrillingMultiAnalysisWidgetInternalState(template.internalState ?? {});

  const drillingMultiAnalysisWidget = new DrillingMultiAnalysisWidgetEntity(
    {
      wellId: options?.wellId ?? null,
      stateParams: internalState.stateParams ?? {},
      type: 'drilling-multi-analysis-widget',
    },
    {
      groupId: template.groupId || null,
      isGroupsDefaultOpened: false,
      uuid: template.uuid,
      isPinned: false,
      isFullscreen: false,
      zIndex: index + 1,
      size: {
        w: size.w,
        h: size.h,
      },
      position: {
        x: position.x,
        y: position.y,
      },
    },
    null,
  );

  return drillingMultiAnalysisWidget;
}
